export const GET_PAGE_BY_SLUG_REQUEST = "GET_PAGE_BY_SLUG_REQUEST"
export const GET_PAGE_BY_SLUG_SUCCESS = "GET_PAGE_BY_SLUG_SUCCESS"
export const GET_PAGE_BY_SLUG_FAILURE = "GET_PAGE_BY_SLUG_FAILURE"
